import { OTA_TICKET_TYPES } from '@/constants/ticketTypes'
import { useFiltersContext } from '@/context'
import { DashboardQueries } from '@/graphql/queries/dashboard.queries'
import { OtaTicketSectionData } from '@/types/Dashboard'

import { useGraphql } from '../useGraphql'

const useOtaTicketSection = () => {
  const [{ marketSegmentFilter }] = useFiltersContext()
  const { marketSegmentIds } = marketSegmentFilter

  const otaTicketSectionQuery = useGraphql<{ agmDashboard: OtaTicketSectionData }>(
    DashboardQueries.QUERY_KEYS.getOtaTicketSection,
    DashboardQueries.getOtaTicketSection(),
    {
      marketSegmentIds: marketSegmentIds,
      ticketTypes: [...OTA_TICKET_TYPES],
    },
    {
      enabled: !!marketSegmentIds?.length,
    },
  )

  return otaTicketSectionQuery
}

export default useOtaTicketSection
